<template>
  <head>
    <meta charset="utf-8" />
    <title>Approved Clearance Certificates</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-header-card">
                <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <div class="d-flex align-items-center">
                    <div class="page-icon bg-success-subtle me-3">
                      <i class="mdi mdi-check-circle text-success"></i>
                    </div>
                    <div>
                      <h4 class="mb-1 fw-bold">Approved Clearance Certificates</h4>
                      <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0">
                          <li class="breadcrumb-item"><a href="javascript: void(0);" class="text-muted">Land & Plots</a></li>
                          <li class="breadcrumb-item"><a href="javascript: void(0);" class="text-muted">Clearance Certificates</a></li>
                          <li class="breadcrumb-item active text-success">Approved</li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                  <router-link :to="{name: 'clearance-dashboard'}" class="btn btn-outline-secondary">
                    <i class="mdi mdi-arrow-left me-1"></i> Back to Dashboard
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarClearance/>

          <!-- Stats Cards -->
          <div class="row g-3 mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-success-subtle rounded-circle me-3">
                      <i class="mdi mdi-check-circle text-success"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Total Approved</p>
                      <h4 class="mb-0 fw-bold text-success">{{ summary.count || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-primary-subtle rounded-circle me-3">
                      <i class="mdi mdi-cash-multiple text-primary"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Total Revenue</p>
                      <h4 class="mb-0 fw-bold text-primary">KES {{ numberFormat(totalRevenue) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-info-subtle rounded-circle me-3">
                      <i class="mdi mdi-calendar-check text-info"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Today's Approved</p>
                      <h4 class="mb-0 fw-bold text-info">{{ todaysApproved }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-warning-subtle rounded-circle me-3">
                      <i class="mdi mdi-calendar-month text-warning"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">This Month</p>
                      <h4 class="mb-0 fw-bold text-warning">{{ thisMonthApproved }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Card -->
          <div class="row">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <!-- Card Header -->
                <div class="card-header bg-white py-3">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <div class="icon-box bg-success text-white rounded me-3">
                        <i class="mdi mdi-check-circle"></i>
                      </div>
                      <div>
                        <h5 class="mb-0 fw-bold">Approved Certificates</h5>
                        <small class="text-muted">Successfully processed certificates</small>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap gap-2 align-items-center">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="keyword" type="text" class="form-control" placeholder="Search..." style="min-width: 180px;">
                          <i class="mdi mdi-magnify search-icon"></i>
                        </div>
                      </div>
                      <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: 140px;">
                      <span class="text-muted">to</span>
                      <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: 140px;">
                      <button @click="getClearanceCertificates" class="btn btn-outline-success" :disabled="loading">
                        <i class="mdi mdi-filter-outline"></i>
                      </button>
                      <button @click="downloadReport" class="btn btn-success" :disabled="certificates.length === 0">
                        <i class="mdi mdi-download me-1"></i> Export
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="bg-light">
                      <tr>
                        <th class="border-0 ps-4">#</th>
                        <th class="border-0">Bill Details</th>
                        <th class="border-0">Property</th>
                        <th class="border-0">Owner</th>
                        <th class="border-0">Location</th>
                        <th class="border-0 text-end">Amount</th>
                        <th class="border-0">Approved By</th>
                        <th class="border-0">Date</th>
                        <th class="border-0 text-center pe-4">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in certificates" :key="index" class="certificate-row">
                        <td class="ps-4 text-muted">{{ ((currentPage - 1) * pageSize) + index + 1 }}</td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="bill-icon bg-success-subtle text-success rounded me-3">
                              <i class="mdi mdi-file-check-outline"></i>
                            </div>
                            <div>
                              <h6 class="mb-0 fw-semibold">{{ item.billNo }}</h6>
                              <span class="badge bg-light text-dark small">{{ item.feeDescription }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.customer || item.description || '-' }}</div>
                          <small class="text-muted">{{ item.category }}</small>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.names }}</div>
                          <small class="text-muted">ID: {{ item.idNo }}</small>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.subCountyName }}</div>
                          <small class="text-muted">{{ item.wardName }}</small>
                        </td>
                        <td class="text-end">
                          <div class="fw-bold text-success">KES {{ numberFormat(item.billTotal) }}</div>
                        </td>
                        <td>
                          <div class="fw-medium small">{{ getApproverName(item.approvedBy) }}</div>
                        </td>
                        <td>
                          <div class="small">{{ formatDate(item.approvedDate) }}</div>
                          <span class="badge bg-success-subtle text-success small">{{ formatTimeAgo(item.approvedDate) }}</span>
                        </td>
                        <td class="text-center pe-4">
                          <div class="btn-group">
                            <button @click="viewCertificate(item)" class="btn btn-sm btn-soft-info" data-bs-toggle="modal" data-bs-target="#viewCertificateModal" title="View">
                              <i class="mdi mdi-eye-outline"></i>
                            </button>
                            <button v-if="getRight('CLEARANCE PRINT')" @click="printCertificate(item)" class="btn btn-sm btn-soft-primary" title="Print">
                              <i class="mdi mdi-printer-outline"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading -->
                    <div class="text-center py-5" v-if="loading">
                      <div class="spinner-border text-success mb-3"></div>
                      <h6 class="text-muted">Loading...</h6>
                    </div>

                    <!-- Empty -->
                    <div class="text-center py-5" v-if="certificates.length === 0 && !loading">
                      <div class="empty-icon mb-3"><i class="mdi mdi-file-search-outline text-muted"></i></div>
                      <h5 class="text-muted fw-bold">No Approved Certificates Found</h5>
                      <p class="text-muted">Adjust your search or date filters.</p>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white py-3" v-if="certificates.length > 0">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <span class="text-muted me-2 small">Show</span>
                      <select v-model="pageSize" class="form-select form-select-sm" style="width: 80px;">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="text-muted small me-3">{{ ((currentPage - 1) * pageSize) + 1 }}-{{ Math.min(currentPage * pageSize, summary.count) }} of {{ summary.count }}</span>
                      <nav>
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage"><i class="mdi mdi-chevron-left"></i></a>
                          </li>
                          <li class="page-item" v-for="page in visiblePages" :key="page" :class="{ active: currentPage === page }">
                            <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage"><i class="mdi mdi-chevron-right"></i></a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- View Modal -->
      <div class="modal fade" id="viewCertificateModal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header bg-success text-white">
              <h5 class="modal-title text-white"><i class="mdi mdi-check-circle me-2"></i>Approved Certificate</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedCertificate">
              <div class="approval-badge d-flex align-items-center p-3 rounded bg-success-subtle mb-4">
                <div class="approval-check me-3"><i class="mdi mdi-check-circle text-success"></i></div>
                <div class="flex-grow-1">
                  <h6 class="mb-0 text-success fw-bold">APPROVED</h6>
                  <small class="text-muted">By {{ selectedCertificate.approvedBy }} on {{ formatDate(selectedCertificate.approvedDate) }}</small>
                </div>
                <span class="badge bg-success">Verified</span>
              </div>

              <div class="row g-3">
                <div class="col-md-6">
                  <div class="info-card p-3 rounded bg-light h-100">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-receipt me-2"></i>Bill Info</h6>
                    <p class="mb-2"><span class="text-muted small d-block">Bill No</span><strong>{{ selectedCertificate.billNo }}</strong></p>
                    <p class="mb-2"><span class="text-muted small d-block">Fee</span><strong>{{ selectedCertificate.feeDescription }}</strong></p>
                    <p class="mb-0"><span class="text-muted small d-block">Amount</span><strong class="text-success">KES {{ numberFormat(selectedCertificate.billTotal) }}</strong></p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-card p-3 rounded bg-light h-100">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-account me-2"></i>Customer Info</h6>
                    <p class="mb-2"><span class="text-muted small d-block">Property</span><strong>{{ selectedCertificate.customer || selectedCertificate.description }}</strong></p>
                    <p class="mb-2"><span class="text-muted small d-block">Owner</span><strong>{{ selectedCertificate.names }}</strong></p>
                    <p class="mb-0"><span class="text-muted small d-block">ID No</span><strong>{{ selectedCertificate.idNo }}</strong></p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="info-card p-3 rounded bg-light">
                    <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-map-marker me-2"></i>Location</h6>
                    <div class="row">
                      <div class="col-md-4"><span class="text-muted small d-block">Sub-County</span><strong>{{ selectedCertificate.subCountyName }}</strong></div>
                      <div class="col-md-4"><span class="text-muted small d-block">Ward</span><strong>{{ selectedCertificate.wardName }}</strong></div>
                      <div class="col-md-4"><span class="text-muted small d-block">Approved</span><strong class="text-success">{{ formatDate(selectedCertificate.approvedDate) }}</strong></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
              <button v-if="getRight('CLEARANCE PRINT')" @click="printCertificate(selectedCertificate)" class="btn btn-primary">
                <i class="mdi mdi-printer me-1"></i> Print
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer"><div class="container-fluid"><div class="row"><div class="col-sm-6"></div></div></div></footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToolBarClearance from "@/components/landrate/ToolBarClearance.vue";
import moment from "moment/moment";
import { execute, getRight, landRate } from "@/api";

export default {
  name: "ApprovedClearanceCertificates",
  components: { NavigationBar, ToolBarClearance },
  data() {
    return {
      loading: false,
      keyword: '',
      dateFrom: '',
      dateTo: '',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      certificates: [],
      selectedCertificate: null,
      summary: { count: 0 }
    }
  },
  computed: {
    totalRevenue() {
      return this.certificates.reduce((sum, cert) => sum + parseFloat(cert.billTotal || 0), 0);
    },
    todaysApproved() {
      const today = moment().format('YYYY-MM-DD');
      return this.certificates.filter(cert => moment(cert.approvedDate).format('YYYY-MM-DD') === today).length;
    },
    thisMonthApproved() {
      const thisMonth = moment().format('YYYY-MM');
      return this.certificates.filter(cert => moment(cert.approvedDate).format('YYYY-MM') === thisMonth).length;
    },
    visiblePages() {
      const pages = [];
      let start = Math.max(1, this.currentPage - 2);
      let end = Math.min(this.totalPages, start + 4);
      if (end - start < 4) start = Math.max(1, end - 4);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    }
  },
  watch: {
    pageSize() { this.currentPage = 1; this.getClearanceCertificates(); },
    keyword() { this.currentPage = 1; this.getClearanceCertificates(); }
  },
  mounted() {
    this.getClearanceCertificates();
  },
  methods: {
    getRight(type) { return getRight(type); },
    numberFormat(num) { return new Intl.NumberFormat("en-GB").format(num || 0); },
    formatDate(date) { return date ? moment(date).format('DD MMM YYYY HH:mm') : ''; },
    formatTimeAgo(date) { return date ? moment(date).fromNow() : ''; },
    getApproverName(approvedBy) {
      if (!approvedBy) return '-';
      const match = approvedBy.match(/^([^(]+)/);
      return match ? match[1].trim() : approvedBy;
    },
    prevPage() { if (this.currentPage > 1) { this.currentPage--; this.getClearanceCertificates(); } },
    nextPage() { if (this.currentPage < this.totalPages) { this.currentPage++; this.getClearanceCertificates(); } },
    goToPage(page) { if (page !== this.currentPage) { this.currentPage = page; this.getClearanceCertificates(); } },

    getClearanceCertificates() {
      this.loading = true;
      this.certificates = [];

      const data = new FormData();
      data.append("function", "getClearanceCertificates");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("search", this.keyword);
      data.append("approvalStatus", "APPROVED");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute(data, landRate)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.certificates = res.data.data.certificates || [];
              this.summary.count = res.data.data.count?.count || 0;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            }
          })
          .catch((e) => { this.loading = false; console.error(e); });
    },

    viewCertificate(item) { this.selectedCertificate = item; },

    printCertificate(item) {
      localStorage['params'] = JSON.stringify({ certificateId: item.id, billNo: item.billNo });
      const routeData = this.$router.resolve({ name: 'clearance-certificate-print' });
      window.open(routeData.href, '_blank');
    },

    downloadReport() {
      if (this.certificates.length === 0) return;
      const headers = ['#', 'Bill No', 'Fee', 'Property', 'Owner', 'ID No', 'Phone', 'Sub County', 'Ward', 'Amount', 'Approved By', 'Date'];
      const csvData = this.certificates.map((item, i) => [
        i + 1, item.billNo, item.feeDescription, item.customer || item.description, item.names, item.idNo,
        item.phoneNumber, item.subCountyName, item.wardName, item.billTotal, item.approvedBy, moment(item.approvedDate).format('YYYY-MM-DD HH:mm')
      ]);
      let csv = headers.join(',') + '\n';
      csvData.forEach(row => { csv += row.map(f => `"${String(f || '').replace(/"/g, '""')}"`).join(',') + '\n'; });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Approved_Certificates_${moment().format('YYYY-MM-DD')}.csv`;
      link.click();
    }
  }
}
</script>

<style scoped>
.page-header-card { background: linear-gradient(135deg, #e8f5e9 0%, #fff 100%); padding: 1.25rem; border-radius: 12px; border: 1px solid #34c38f33; }
.page-icon { width: 56px; height: 56px; display: flex; align-items: center; justify-content: center; border-radius: 12px; font-size: 28px; }
.mini-stat-card { border-radius: 12px; transition: all 0.3s ease; }
.mini-stat-card:hover { transform: translateY(-3px); box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important; }
.mini-stat-icon { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; font-size: 24px; }
.icon-box { width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
.bill-icon { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
.search-box { position: relative; }
.search-box .search-icon { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #adb5bd; }
.certificate-row:hover { background-color: rgba(52, 195, 143, 0.05); }
.btn-soft-info { color: #50a5f1; background-color: rgba(80, 165, 241, 0.1); border: none; }
.btn-soft-info:hover { color: #fff; background-color: #50a5f1; }
.btn-soft-primary { color: #556ee6; background-color: rgba(85, 110, 230, 0.1); border: none; }
.btn-soft-primary:hover { color: #fff; background-color: #556ee6; }
.bg-success-subtle { background-color: rgba(52, 195, 143, 0.15) !important; }
.bg-primary-subtle { background-color: rgba(85, 110, 230, 0.15) !important; }
.bg-info-subtle { background-color: rgba(80, 165, 241, 0.15) !important; }
.bg-warning-subtle { background-color: rgba(241, 180, 76, 0.15) !important; }
.empty-icon { width: 100px; height: 100px; display: flex; align-items: center; justify-content: center; margin: 0 auto; background: rgba(108, 117, 125, 0.1); border-radius: 50%; }
.empty-icon i { font-size: 50px; }
.approval-check { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; }
.approval-check i { font-size: 32px; }
.info-card { border: 1px solid #e9ecef; }
.page-link { cursor: pointer; border-radius: 6px !important; margin: 0 2px; }
.page-item.active .page-link { background-color: #34c38f; border-color: #34c38f; }
</style>